import { createContext, useMemo } from "react";

type Props = {
  children?: React.ReactNode;
  currentPage: number,
  setPage: (page: string | number) => void,
  scrollRef: React.RefObject<HTMLDivElement>
}

export const PaginationContext = createContext<Props>({} as Props);

export const PaginationProvider = ({ children, currentPage, setPage, scrollRef }: Props) => {
  const values = useMemo(() => ({ currentPage, setPage, scrollRef }), [currentPage, setPage, scrollRef]);

  return (
    <PaginationContext.Provider value={values}>
      {children}
    </PaginationContext.Provider>
  )
};
